/**
 * Created by Administrador on 27/07/2019.
 */
(function () {
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('paymentWeight', {
                parent: 'app',
                url: '/paymentWeight',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/report/manifest/paymentWeight/paymentWeight.html',
                        controller: 'paymentWeightCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            'tabs': ['tabService', function (tabService) {
                                return tabService.getTabManifestos('paymentWeight')
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['generalManifest']);
                            }],
                            airports:['airportService',function(airportService){
                                return airportService.getAirportsActiveDisable(true);
                            }]
                        }
                    }
                }
            });
    }
})();
